const getters = {
    emailtemplate: (state) => state.emailtemplate,
    emailtemplateid: (state) => state.emailtemplateid,
    loading: state => state.loading,
    platformTypeList : state => state.platformTypeList,
    contentTemplate : state => state.contentTemplate,
    contentTemplateId : state => state.contentTemplateId
};

export default getters;